<form [formGroup]="form" (ngSubmit)="onSubmit()" class="credit-note-association py-4 px-1 px-sm-5 position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="close()"></i>
    <h4 class="text-center text-strong">Asociar notas crédito</h4>

    <div class="alert alert-info" role="alert">
        <p class="mb-0">Indica el consecutivo de la nota crédito en Siigo y el número de la factura a la que se asocia.
            Puedes agregar tantas filas como necesites.</p>
    </div>

    <div formArrayName="associations">
        <div *ngFor="let association of associations.controls; let i = index" [formGroupName]="i"
            class="credit-note-association__row">
            <span class="credit-note-association__index">{{i + 1}}</span>
            <mat-form-field appearance="outline" class="credit-note-association__field">
                <mat-label>Nota crédito<span class="asterisk">*</span></mat-label>
                <input matInput type="text" formControlName="name" placeholder="Ej: NC-2-1588">
                <mat-error *ngIf="association.get('name').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="credit-note-association__field">
                <mat-label>N° de factura<span class="asterisk">*</span></mat-label>
                <input matInput type="text" formControlName="number" placeholder="Ej: 21025">
                <mat-error *ngIf="association.get('number').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <button mat-icon-button type="button" matTooltip="Quitar fila" (click)="removeAssociation(i)"
                [disabled]="associations.length <= 1" class="credit-note-association__remove">
                <i class="fas fa-minus-circle"></i>
            </button>
        </div>
    </div>

    <button mat-button type="button" class="credit-note-association__add button-width-auto"
        (click)="addAssociation($event)">
        <i class="fas fa-plus-circle mr-2"></i>
        <span>Agregar nota crédito</span>
    </button>

    <div class="w-100 mt-4 button-container">
        <button type="button" mat-raised-button class="primary-secondary" color="primary" (click)="close()"
            [disabled]="isLoading">
            Cancelar
        </button>
        <button mat-raised-button class="bg-color-primary" color="primary" type="submit" [disabled]="isLoading">
            Asociar ({{associations.length}})
        </button>
    </div>
</form>
